import { useCallback } from "react";

import type { ReservationRefundRequestInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailUpdateRefundRequest = (hotelID: string, reservationID: string) => {
	const { onUpdateReservationDetailUpdateRefundRequest: _onUpdateReservationDetailUpdateRefundRequest } =
		MutationRepository.useReservationDetailUpdateRefundRequestUpdateMutation();

	/**
	 * 予約詳細の返金リクエストを実行
	 */
	const onUpdateReservationDetailUpdateRefundRequest = useCallback(
		async (
			refundPrice: ReservationRefundRequestInput["refundPrice"],
			refundReason: ReservationRefundRequestInput["refundReason"],
		) => {
			const input: ReservationRefundRequestInput = {
				refundPrice,
				refundReason,
				hotelID,
				reservationID,
			} satisfies ReservationRefundRequestInput;
			await _onUpdateReservationDetailUpdateRefundRequest(input);
		},
		[_onUpdateReservationDetailUpdateRefundRequest, hotelID, reservationID],
	);

	return {
		onUpdateReservationDetailUpdateRefundRequest,
	};
};
